var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpened)?_c('TaskViewMembersPopup',_vm._b({on:{"change":_vm.toggleSelectedUsers,"submit":_vm.submit},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'TaskViewMembersPopup',_vm.props,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }